import React, { useEffect } from 'react';
import { PartnerType } from 'Enums';
import { Main, TitleActionBar } from 'Components/utility';
import { cutString } from 'Utilities/dataHelpers';
import mediator from 'Utilities/mediator';
import CommercialApi from './CommercialApi';
import InboundApi from './InboundApi';
import PartnerApi from './PartnerApi';
import PumpPartner from './PumpPartner';
import Redox from './Redox';
const isValidPartnerType = (type) => {
    return Object.values(PartnerType).includes(type);
};
const PartnerConnection = ({ data: { partnerConnection } }) => {
    useEffect(() => {
        if (!partnerConnection || !isValidPartnerType(partnerConnection.partner.type)) {
            mediator.publish('router:navigate', '/connections');
        }
    }, [partnerConnection]);
    if (!partnerConnection) {
        return null;
    }
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "PartnerConnection", title: cutString(partnerConnection.partner.name, 20), onBack: () => mediator.publish('router:navigate', '/connections') }),
        {
            [PartnerType.InboundApi]: React.createElement(InboundApi, { partnerConnection: partnerConnection }),
            [PartnerType.Redox]: React.createElement(Redox, { partnerConnection: partnerConnection }),
            [PartnerType.PartnerApi]: React.createElement(PartnerApi, { partnerConnection: partnerConnection }),
            [PartnerType.CommercialAPI]: React.createElement(CommercialApi, { partnerConnection: partnerConnection }),
            [PartnerType.PumpPartner]: React.createElement(PumpPartner, { partnerConnection: partnerConnection }),
        }[partnerConnection.partner.type] ??
            (() => {
                mediator.publish('router:navigate', '/connections');
                return null;
            })()));
};
export default PartnerConnection;
